/* eslint-disable radix */
/* eslint-disable no-plusplus */

export function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function validateCPF(value: string) {
  let rest: number;
  let sum = 0;
  const CPF = value.replace(/\D/g, '');

  if (CPF === '00000000000') return false;

  for (let i = 1; i <= 9; i++)
    sum += parseInt(CPF.substring(i - 1, i)) * (11 - i);
  rest = (sum * 10) % 11;

  if (rest === 10 || rest === 11) rest = 0;
  if (rest !== parseInt(CPF.substring(9, 10))) return false;

  sum = 0;
  for (let i = 1; i <= 10; i++)
    sum += parseInt(CPF.substring(i - 1, i)) * (12 - i);
  rest = (sum * 10) % 11;

  if (rest === 10 || rest === 11) rest = 0;
  if (rest !== parseInt(CPF.substring(10, 11))) return false;
  return true;
}

export function validatePhoneNumber(value: string): boolean {
  const phoneNumber = value.replace(/\D/g, '');
  if (phoneNumber.length < 11) {
    return false;
  }
  const wrongNumbers = [
    '00000000000',
    '11111111111',
    '22222222222',
    '33333333333',
    '44444444444',
    '55555555555',
    '66666666666',
    '77777777777',
    '88888888888',
    '99999999999',
  ];
  if (wrongNumbers.includes(phoneNumber)) {
    return false;
  }
  return true;
}

export function validateBirthday(value: string) {
  const date = value.replace(/\D/g, '');

  if (date.length < 8) {
    return false;
  }

  const day = Number(date.slice(0, 2));
  if (day <= 0 || day > 31) {
    return false;
  }

  const month = Number(date.slice(2, 4));
  if (month <= 0 || month > 12) {
    return false;
  }

  return true;
}
